import { Injectable, inject } from '@angular/core';
import {
  ApiDependencyProviderService,
  CollectionRequest,
  CollectionResponse,
} from '@web/common';
import { map, Observable } from 'rxjs';
import { valueOrDefault } from '@web/utils';
import { DictionaryPhoneNumberCollectionItemResponse } from '../responses/dictionary-phone-number-collection-item.response';

@Injectable({
  providedIn: 'root',
})
export class DictionaryPhoneNumberApiService {
  private readonly provider = inject(ApiDependencyProviderService);

  public fetchCollection(options: {
    request: CollectionRequest;
    cacheable?: boolean;
    skipByLoading?: boolean;
  }): Observable<
    CollectionResponse<DictionaryPhoneNumberCollectionItemResponse>
  > {
    const path = 'dictionary/phone-country';
    const url = this.provider.httpUrlFactory.withQueryParams(
      this.hostUrl(),
      path,
      this.provider.httpHelper.collectionRequestToQueryParams(options.request),
    );

    const context = this.provider.httpContextBuilder
      .withOptionalCacheInterceptor(() =>
        valueOrDefault(options.cacheable, false),
      )
      .withOptionalSkipByLoadingInterceptor(() =>
        valueOrDefault(options.skipByLoading, false),
      )
      .build();

    return this.provider.http
      .get(url, { context })
      .pipe(
        map(
          this.provider.httpHelper.bodyToCollectionResponse(
            DictionaryPhoneNumberCollectionItemResponse,
          ),
        ),
      );
  }

  private hostUrl(): string {
    return this.provider.environment.ApiHostUrl.Shop;
  }
}
